module.exports = __webpack_public_path__ + "img/1.39384550.jpeg";